import React, { useEffect, useState } from 'react';

import { CharacterSheetInterface, Sense, SENSES } from "@dndModels";

import FlexBox from '@components/layout/FlexBox';
import CommonUtilities from '@utilities/common_utilities';
import SelectStringBox from '@components/input/selects/SelectStringBox';
import { FIVES_0_to_100 } from '@dndModels/Constants';

interface Props {
  char: CharacterSheetInterface;
}

const common_util = CommonUtilities.getInstance();

export default function CharacterSenseCustomizations({
  char,
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [editing_sense, setEditingSense] = useState<Sense | undefined>(undefined);
  const [ping, setPing] = useState(false);

  const customizations = char.customizations;

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading]);

  const renderSenseCustomization = (sense: Sense) => {
    // debugger;
    let str = ``;
    const char_sense = char.mind.senses.find(o => o.sense_id === sense._id);
    if (customizations.overrides.senses[sense._id]) {
      str += ` (Overridden)`;
    }
    return (
      <>
        <FlexBox className="clickable" onClick={() => setEditingSense(editing_sense && editing_sense._id === sense._id ? undefined : sense) }>
          <FlexBox direction="column">
            <FlexBox className="header">
              { sense.name }: Current { char_sense?.range??0 }
            </FlexBox>
          </FlexBox>
          { (customizations.overrides.senses[sense._id]) && 
            <FlexBox className="small_label gray">{ str }</FlexBox>
          }
        </FlexBox>
      </>
    );
  }

  const renderSelectedField = () => {
    if (editing_sense) {
      return (
        <FlexBox direction="column">
          <FlexBox className="header centered">Customizations for { editing_sense.name }</FlexBox>
          <FlexBox>
            <SelectStringBox 
              name="Override"
              value={ char.customizations.overrides.senses[editing_sense._id] === undefined ? "Don't Override" : `${char.customizations.overrides.senses[editing_sense._id]}` } 
              options={["Don't Override", ...FIVES_0_to_100]}
              onChange={ async (changed: string) => {
                // debugger;
                if (changed === "Don't Override") {
                  delete char.customizations.overrides.senses[editing_sense._id];
                } else {
                  char.customizations.overrides.senses[editing_sense._id] = +changed;
                }
                setPing(!ping);
                char.changed();
                char.subscription_holder.recalculate();
              }}
            />
          </FlexBox>
          <FlexBox>
            <SelectStringBox 
              name="Modifier"
              value={ char.customizations.modifiers.senses[editing_sense._id] === undefined ? "Don't Modify" : `${char.customizations.modifiers.senses[editing_sense._id]}` } 
              options={["Don't Modify", ...FIVES_0_to_100]}
              onChange={ async (changed: string) => {
                if (changed === "Don't Modify") {
                  delete char.customizations.modifiers.senses[editing_sense._id];
                } else {
                  char.customizations.modifiers.senses[editing_sense._id] = +changed;
                }
                setPing(!ping);
                char.changed();
                char.subscription_holder.recalculate();
              }}
            />
          </FlexBox>
        </FlexBox>
      );
    }
    return null;
  }

  return (
    <FlexBox direction="row">
      <FlexBox xs_expand={0} direction="column">
        { SENSES.map(sense => renderSenseCustomization(sense)) }
      </FlexBox>
      <FlexBox>
        { renderSelectedField() }
      </FlexBox>
    </FlexBox>
  );
}

